var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-2xl"},[_vm._v("Dashboard")]),_c('h2',[_vm._v("(analitika / opšti pregled)")]),_c('h3',{staticClass:"font-bold text-3xl mt-24"},[_vm._v("CONTENT")]),_c('h3',{staticClass:"font-bold text-3xl"},[_vm._v("TO BE DETERMINED")])])
}]

export { render, staticRenderFns }